import SyncIcon from "@mui/icons-material/Sync";
import {
    Alert,
    AlertProps,
    CircularProgress,
    IconButton,
    Snackbar,
    Tooltip,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Device_Service } from "../../services/device/device-service";
import UserContext, { User_Type } from "../UserContext";

const initialFeedback: {
    message: string;
    loading: boolean;
    show: boolean;
    severity?: AlertProps["severity"];
} = {
    message: "",
    loading: false,
    show: false,
    severity: undefined,
};

type Props = {
    rows: any[];
    disabled?: boolean;
    onSuccess?: (feedback: typeof initialFeedback) => void;
};

const SyncPortalUser = ({ rows, disabled, onSuccess }: Props) => {
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState(initialFeedback);
    const [organizationCode, setOrganizationCode] = useState("");
    const [apiKey, setApiKey] = useState("");
    const { user } = useContext(UserContext);

    async function handleVerifyUser(rows: any[]) {
        setLoading(true);
        const messages: string[] = [];
        console.log(rows);

        if (rows == undefined) return;

        for (const row of rows) {
            const [data, error] = await Device_Service.sync_single_portal_user(
                { user: row.id, branch: [row.branch.id] },
                organizationCode,
                apiKey
            );

            if (data) {
                messages.push(`${row.name || "User"}: ${data.message}`);
            } else {
                messages.push(
                    `${row.name || "User"}: ${error?.message || "Failed"}`
                );
            }
        }

        setFeedback({
            loading: false,
            message: messages.join("\n"), // Join all messages together
            severity: "info", // or "success" if all passed
            show: true,
        });

        setLoading(false);
    }

    useEffect(() => {
        if (user?.user_type === User_Type.Admin) {
            setOrganizationCode(user?.organization?.code);
            setApiKey(user.organization.apiKey[0].key);
        }
    }, [user?.user_type]);

    return (
        <div>
            <Tooltip title="Sync  User">
                <IconButton
                    onClick={() => (rows ? handleVerifyUser(rows) : undefined)}
                    disabled={loading || disabled}
                    size="small"
                >
                    {loading ? (
                        <CircularProgress size="1rem" />
                    ) : (
                        <SyncIcon fontSize="small" />
                    )}
                </IconButton>
            </Tooltip>

            <Snackbar
                open={feedback.show}
                autoHideDuration={4000}
                onClose={() => setFeedback((f) => ({ ...f, show: false }))}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    severity={feedback.severity}
                    onClose={() => setFeedback((f) => ({ ...f, show: false }))}
                    variant="filled"
                    sx={{ width: "100%", whiteSpace: "pre-line" }}
                >
                    {feedback.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default SyncPortalUser;
